export class FilterEditController {

    constructor($scope, $rootScope, AuthService, UserService, RegionService, $http, toastr) {
        $scope.vm = this;
        this.scope = $scope;
        this.UserService = UserService;
        this.rootScope = $rootScope;
        this.RegionService = RegionService;
        this.http = $http;
        this.toastr = toastr;
        this.scope.regions = [];
        this.scope.filter = {
            grid : true,
            type : "double",
            min : 18,
            max : 99,
            postfix: "años",
            region: null
        };

      this.RegionService.getRegionsList()
        .then((response) => { let regions = response.data;
          this.scope.regions = regions.data;
        })
        .catch((response) => { let error = response.data;
          console.log("Can`t get regions from database");
        });

        this.scope.vm.UserService.getCurrentUser()
        .then((response) => { let user = response.data;
          this.rootScope.currentUserProfile = user.data;

          const filters = (this.rootScope.currentUserProfile && this.rootScope.currentUserProfile.filters) || {};
          $("#age_slider_id").ionRangeSlider({
              type: this.scope.filter.type,
              grid: false,
              min: this.scope.filter.min,
              max: this.scope.filter.max,
              from: filters.minage != null ? filters.minage : this.scope.filter.min,
              to: filters.maxage != null ? filters.maxage : this.scope.filter.max,
              postfix: this.scope.filter.postfix,
              onChange:  (data)=> {
                this.rootScope.currentUserProfile.filters.minage = data.from;
                this.rootScope.currentUserProfile.filters.maxage = data.to;
              }
            });

          })
        .catch((response) => {
          console.log("Can't get user data for filter edit");
        });

      this.scope.savenewFilters = () => {
        this.rootScope.currentUserProfile.filters.region = this.rootScope.currentUserProfile.filters.region == "" ? null : this.rootScope.currentUserProfile.filters.region;

        this.UserService.updateUser(this.rootScope.currentUserProfile)
          .then((response) => { let user = response.data;if(user.success){
            this.toastr.info('Sus filtros han sido guardados correctamente');
          } })
          .catch((response) => { let error = response.data; let status = response.status;
            if(status==409){
              this.toastr.warning('No hay cambios para guardar.');
            }
          });
      };
    }
}
